import { handleActions } from 'redux-actions';
import {
  GridFilters,
  initialStateList,
} from './GridFiltersReducer';

const initialState = {
  allNotes: { ...initialStateList },
};

export const Notes = handleActions({
  ...GridFilters,
}, initialState);

const getNotes = state => state.Notes;

export const getNotesList = (state, list) => {
  const notes = getNotes(state);
  return notes[list] || undefined;
};
